// UI Components
import { TableSearch } from "ui/components/Table/TableSearch";

// Services & API
import { initialDataWithPagination } from "services/api/consts";

// Constants
import { CALCULATION_VEHICLE_INSURANCE_SEARCH_COLUMNS } from "./consts";

// Types
import { VehicleInsuranceSearchResultsProps } from "./types";

// React
import { memo } from "react";

const VehicleInsuranceSearchResults: React.FC<
  VehicleInsuranceSearchResultsProps
> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  return (
    <>
      <TableSearch
        columns={CALCULATION_VEHICLE_INSURANCE_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(VehicleInsuranceSearchResults);
